import React, {
  memo,
  ReactElement,
} from 'react';

import { DialogContent } from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';

import Container, { Header, CloseButton } from './style';

interface ModalProps {
  exibe: boolean;
  toggle: (e?: {}, reason?: 'backdropClick' | 'escapeKeyDown') => void;
  conteudo?: ReactElement;
  cabecalho?: ReactElement;
  className?: string;
}

function Modal({
  exibe,
  toggle,
  cabecalho,
  conteudo,
  className,
}: ModalProps) {
  return (
    <Container
      className={className}
      open={exibe}
      onClose={(e, reason) => toggle(e, reason)}
      maxWidth="xs"
    >
      <Header>
        <CloseButton onClick={() => toggle()}>
          <CloseIcon />
        </CloseButton>
        {cabecalho}
      </Header>
      <DialogContent>
        {conteudo}
      </DialogContent>
    </Container>
  );
}

export default memo(Modal);
